module.exports = __webpack_public_path__ + "static/media/servicerocket_logo.adb74a4b.png";